import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoadingData: false,
  isLoading: false,
  patients: [],
  message: null,
  pageSize: "10",
  page: "1",
  totalPages: 1,
  filters: {
    search: "",
  },
  sort: {
    key: "firstName",
    direction: "asc",
  },
  // pagination: {
  //   page: 1,
  //   pageSize: 10,
  //   totalPages: 10,
  // },
};

const resetState = (state, keys) => {
  keys.forEach((key) => {
    state[key] = initialState[key];
  });
};

export const patientsSlice = createSlice({
  name: "patients",
  initialState,
  reducers: {
    onLoadingPatients: (state) => {
      state.isLoadingData = true;
      state.message = null;
    },
    onLoading: (state) => {
      state.isLoading = true;
      state.message = null;
    },
    onLoaded: (state) => {
      state.isLoading = false;
      state.message = null;
    },
    onLoadPatients: (state, { payload }) => {
      const { page, totalPages, patients } = payload;
      state.isLoadingData = false;
      state.message = null;
      state.patients = patients;
      state.page = page;
      state.totalPages = totalPages;
    },
    onFailedPatients: (state, { payload }) => {
      state.isLoadingData = false;
      state.message = {
        type: "errorPatients",
        text: payload,
      };
      resetState(state, ["patients"]);
    },
    onErrorMessage: (state, { payload }) => {
      state.isLoading = false;
      state.message = {
        type: "error",
        text: payload,
      };
    },
    onSuccessMessage: (state, { payload }) => {
      state.isLoading = false;
      state.message = {
        type: "success",
        text: payload,
      };
    },
    changePageSize: (state, { payload }) => {
      state.pageSize = payload;
    },
    changePage: (state, { payload }) => {
      state.page = payload;
    },
    onUpdatePatient: (state, { payload }) => {
      const index = state.patients.findIndex(
        (patient) => patient.id === payload.id
      );
      if (index !== -1) {
        state.patients[index] = {
          ...payload,
        };
      }
    },
    changeSort: (state, { payload }) => {
      state.sort = payload;
    },
    changeFilters: (state, { payload }) => {
      state.filters = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  onLoadingPatients,
  onLoading,
  onLoaded,
  onLoadPatients,
  onFailedPatients,
  onErrorMessage,
  onSuccessMessage,
  changePageSize,
  changePage,
  onUpdatePatient,
  changeSort,
  changeFilters,
} = patientsSlice.actions;
